export default "__VITE_ASSET__BqydXxoP__"